import React from 'react';
import styles from './Cells.module.scss';

import StyledLink from 'components/StyledLink';
import CustomCheckbox from 'components/CustomCheckbox/CustomCheckbox';

import { ASSET_DETAILED_PATH, ASSETS_LIST_PATH } from 'constants/routeConstants';

export function AssetCell({ canSelect, isSelected, onChange, asset, onLinkClick }) {
  const { id, drCode } = asset;

  return (
    <div className={styles.asset}>
      <div className={styles.asset__select}>
        {canSelect && <CustomCheckbox small sendEvent value={isSelected} onChange={onChange} />}
      </div>
      <StyledLink
        bold
        to={{ pathname: `${ASSET_DETAILED_PATH}/${id}`, state: { from: ASSETS_LIST_PATH } }}
        onClick={onLinkClick}>
        {drCode || ''}
      </StyledLink>
    </div>
  );
}
